export const blogFr = {
  // Blog page
  blogHeroTitle: "Histoires SheCan",
  blogHeroSubtitle: "Vraies femmes. Vraie force. Vraies histoires.",
  latestArticles: "Derniers Articles",
  readMore: "Lire la Suite",
  byAuthor: "Par",
  
  // Categories
  empowerment: "Autonomisation",
  career: "Carrière",
  wellness: "Bien-être",
  relationships: "Relations",
  personalGrowth: "Croissance Personnelle",
  inspiration: "Inspiration",
  mothersWisdom: "Sagesse de Maman",
  grandmothersLetters: "Lettres de Grand-mères"
};

export default blogFr;
